import { HomeCard } from './HomeCard.js';

/**
 * No events API exists yet, so this shows an honest empty state rather than invented meetings.
 * When one lands, feed its rows in here.
 */
export function UpcomingEvents() {
  return (
    <HomeCard
      title="Upcoming Events"
      viewAll={{ to: '/calendar', label: 'View all' }}
      isEmpty
      emptyTitle="No upcoming events"
      emptyDescription="Company and team events will show here."
    />
  );
}
